<template>
    <div class="main mt15">
        <Row>
            <Col span="4" class="layout-menu-left">
            <Menu width="auto" :active-name="active" @on-select="change">
                <MenuItem name="1">
                我的投保单
                </MenuItem>
                <MenuItem name="2">
                我的保单
                </MenuItem>
                <MenuItem name="3">
                我的批改单
                </MenuItem>
                <MenuItem name="4">
                我的订单
                </MenuItem>
                <MenuItem name="5">
                我的暂存
                </MenuItem>
            </Menu>
            </Col>
            <Col span="20">
                <router-view class="mt15"></router-view>
            </Col>
        </Row>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                active: '1',
            }
        },
        mounted () {
            this.$nextTick(() => {
                this.changeRoute(this.$route.name)
            })
        },
        methods: {
            change (value) {
                let url = "";
                if (value == '1') {
                    url = "/my/customizedCCIC/insurance";
                } else if (value == '2') {
                    url = "/my/customizedCCIC/policy";
                } else if (value == '3') {
                    url = "/my/customizedCCIC/rider";
                } else if (value == '4') {
                    url = "/my/customizedCCIC/order";
                } else if (value == '5') {
                    url = "/my/customizedCCIC/drafts";
                }
                url != this.$route.path && this.$router.push({
                    path: url,
                    query: this.$route.query
                })
            },
            changeRoute (routeName) {
                if (routeName == "insuranceCCIC") {
                    this.active = "1";
                } else if (routeName == "policyCCIC") {
                    this.active = "2";
                } else if (routeName == "riderCCIC") {
                    this.active = "3";
                } else if (routeName == "orderCCIC") {
                    this.active = "4";
                } else if (routeName == "draftsCCIC") {
                    this.active = "5";
                }
            }
        },
        watch: {
            '$route.name' (v) {
                this.changeRoute(this.$route.name);
            }
        }
    }
</script>
<style scoped>
    .main {
        background: #fff;
        /* margin-top: 102px; */
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi.vue